import {
  Create,
  SimpleForm,
  ReferenceInput,
  AutocompleteInput,
  TextInput,
  FormDataConsumer,
} from 'react-admin'
import Grid from '@mui/material/Grid'

import { validateRequired } from '../../utils/validate'
import GridContainer from '../../components/GridContainer'
import { ROLES } from '../../components/constants'

import CsDeleteAccountPreview from './CsDeleteAccountPreview'

const CsDeleteAccountCreate = props => {
  return (
    <Create redirect="list" undoable={false} {...props}>
      <SimpleForm>
        <GridContainer>
          <Grid item xs={12}>
            <ReferenceInput
              label="Username"
              source="userId"
              reference="users"
              filter={{
                role: ROLES.USER,
              }}>
              <AutocompleteInput
                optionText="username"
                options={{
                  fullWidth: true,
                  required: true,
                }}
                variant="standard"
                validate={validateRequired('user')}
                filterToQuery={searchText => ({
                  username: { $iLike: `%${searchText}%` },
                  role: ROLES.USER,
                })}
              />
            </ReferenceInput>
          </Grid>

          <Grid item xs={12}>
            <FormDataConsumer>
              {({ formData }) =>
                formData && <CsDeleteAccountPreview userId={formData.userId} />
              }
            </FormDataConsumer>
          </Grid>

          <Grid item xs={12}>
            <TextInput
              source="reason"
              fullWidth
              variant="standard"
              required
              validate={validateRequired('Reason')}
            />
          </Grid>
        </GridContainer>
      </SimpleForm>
    </Create>
  )
}

export default CsDeleteAccountCreate
